import React from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import { Mobile, NotMobile } from "../../../../../hocs/Responsive";
import { getCategoriesBlockedByWebFilter } from "../../../../../store/categories/categories.selectors";
import { getCategories } from "../../../../../store/root.selectors";
import { ProtectionEditorDialogContainer } from "../../webFilters/protectionEditorDialog/ProtectionEditorDialogContainer";
import { ProtectionEditor } from "../../webFilters/protectionEditor/ProtectionEditor";
import { changeCategories } from "../schedules.actions";
import { ScheduleCategoriesHeader } from "./scheduleCategoriesHeader/ScheduleCategoriesHeader";

const getNamesToBlock = (categoriesNames, blockedBySchedule) =>
  _.union(blockedBySchedule, categoriesNames);
const getNamesToAllow = (categoriesNames, blockedBySchedule) =>
  _.without(blockedBySchedule, ...categoriesNames);

const getScheduleCategories = (categories, blockedBySchedule) => {
  const blocked = categories.filter((category) =>
    _.includes(blockedBySchedule, category.name)
  );
  const allowed = _.difference(categories, blocked);

  return {
    allowed,
    blocked,
  };
};

export const ScheduleCategories = ({
  type,
  schedules,
  isActive,
  profile: profileId,
  disabled,
}) => {
  const blockedBySchedule = schedules[0] && schedules[0].categories;
  const categories = useSelector(getCategories);
  const scheduleCategories = getScheduleCategories(
    categories,
    blockedBySchedule
  );

  const blockedByWebFilter = useSelector(
    getCategoriesBlockedByWebFilter(profileId)
  );

  const dispatch = useDispatch();
  const changeStatus = (categoriesNames) =>
    dispatch(changeCategories(type, profileId, categoriesNames));

  return (
    <div className="schedule__categories">
      <Mobile>
        <ProtectionEditorDialogContainer
          categories={scheduleCategories}
          blockedByWebFilter={blockedByWebFilter}
          changeStatus={changeStatus}
          profileId={profileId}
          isActive={isActive}
        />
      </Mobile>
      <NotMobile>
        <ProtectionEditor
          header={<ScheduleCategoriesHeader />}
          categories={scheduleCategories}
          blockedByWebFilter={blockedByWebFilter}
          onBlock={(categoriesNames) =>
            changeStatus(getNamesToBlock(categoriesNames, blockedBySchedule))
          }
          onAllow={(categoriesNames) =>
            changeStatus(getNamesToAllow(categoriesNames, blockedBySchedule))
          }
          profileId={profileId}
          disabled={disabled}
        />
      </NotMobile>
    </div>
  );
};
